import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

const functions = getFunctions();

export const authorizeLinear = () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated.");
    }

    const authUrl = `https://us-central1-${functions.app.options.projectId}.cloudfunctions.net/linearAuth?state=${user.uid}`;
    window.open(authUrl, "_blank", "width=800,height=600");
};

export const getLinearTeams = async () => {
    const getLinearTeamsCallable = httpsCallable(functions, "getLinearTeams");
    try {
        const result = await getLinearTeamsCallable();
        return result.data;
    } catch (error) {
        console.error("Error getting Linear teams:", error);
        throw error;
    }
};

export const createLinearIssue = async (title, description, teamId) => {
    const createLinearIssueCallable = httpsCallable(functions, "createLinearIssue");
    try {
        const result = await createLinearIssueCallable({ title, description, teamId });
        return result.data;
    } catch (error) {
        console.error("Error creating Linear issue:", error);
        throw error;
    }
};
